import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToggleDropdownDirective } from './toggle-dropdown.directive';
import { FiToggleDropdownOffDirective } from './toggle-dropdown-off.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [ToggleDropdownDirective, FiToggleDropdownOffDirective],
    exports: [ToggleDropdownDirective, FiToggleDropdownOffDirective],
})
export class ToggleDropdownModule {}
